module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-Medium.f53f50bf.ttf";